import { gql, useMutation } from '@apollo/client';

import {
  JobsDocument,
  type ExpireJobMutation,
  type ExpireJobMutationVariables,
} from 'src/graphql/__generated__';

import { useGetQueryJobsOptions } from './useQueryJobs';

const wait = (ms: number): Promise<void> =>
  new Promise((resolve) => setTimeout(resolve, ms));

export const EXPIRE_JOB_MUTATION = gql`
  mutation ExpireJob($input: ExpireJobInput!) {
    expireJob(input: $input) {
      jobId
    }
  }
`;

export const useMutateExpireJob = ({ jobId }: { jobId: string }) => {
  const [expireJobFunction, { data, loading, error }] = useMutation<
    ExpireJobMutation,
    ExpireJobMutationVariables
  >(EXPIRE_JOB_MUTATION);

  const options = useGetQueryJobsOptions();

  return {
    expireJob: async (expiryTime?: string) => {
      await expireJobFunction({
        variables: {
          input: {
            expiryTime,
            jobId,
          },
        },
        refetchQueries: [
          {
            query: JobsDocument,
            ...options,
          },
        ],
        onQueryUpdated: async (observableQuery) => {
          // expire job mutation is not instant, so we need to wait a bit before refetching
          await wait(1500);
          observableQuery.refetch();
        },
      });
    },
    data,
    loading,
    error,
  };
};
